import { useMutation, useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { axios } from '@repository/RequestClient';
import { RemoteProfilesRepo } from '@repository/profiles/ProfilesRepo';
import { ProfileBasicInfoRq } from '@domain/rq/profile/ProfileBasicInfoRq';
import ProfileBasicVO from '@domain/vo/profile/ProfileBasicVO';
import { ProfileBasicFormVO } from '@domain/vo/profile/ProfileBasicFormVO';
// import MockProfileRepo from "@repository/mock/MockProfileRepo";

export const keys = ['profile', 'basic'];

const remoteProfilesRepo = new RemoteProfilesRepo();
// const profileRepo = new MockProfileRepo();

const fetchProfileBasic = async () => {
  const { data } = await remoteProfilesRepo.fetchProfileBasic();
  //로컬에서 CORS policy 관련 에러가 떠서 기본정보 접근 안되는 경우가 있습니다. 방어코드로 추가하였습니다.
  try {
    if (data.profileImageUid) await axios.get(`/file/${data.profileImageUid}`);
  } catch (e) {
    console.error(e);
  }

  return new ProfileBasicVO(data);
};

export default function useProfileBasic(isEnabled: boolean) {
  return useQuery([...keys, 'view'], fetchProfileBasic, {
    enabled: isEnabled,
  });
}

const fetchSaveProfileBasic = async (vo: ProfileBasicFormVO) => {
  const { data } = await remoteProfilesRepo.fetchSaveProfileBasic(new ProfileBasicInfoRq(vo));
  return data;
};

export function useFetchSaveProfileBasic(onSuccess: () => void, onError?: (e: AxiosError) => void) {
  return useMutation((vo: ProfileBasicFormVO) => fetchSaveProfileBasic(vo), {
    onSuccess: onSuccess,
    onError: onError,
  });
}
